import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ckhq67rqe: FaireProductEntity = {
  token: "p_2ckhq67rqe",
  type: "product",
  name: "11 Units FREEBIE- Topical Wellness Best Sellers",
  brandToken: "b_56mx5j1v94",
  brandName: "Magnum Solace",
  imageUrl:
    "https://cdn.faire.com/fastly/e29158ff9a4351648faa8a28567db69d69276598e0a3f57f4ad784088dfea183.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b79e39ef5a83962aaa3b7d76a2307e0d32a404d170f36a958120ae05834e5bb7.jpeg",
    "https://cdn.faire.com/fastly/e9fa9404e7b3598809e6e2728ebe282ff3ddc56fa375f44506c456e7bfce960c.jpeg",
    "https://cdn.faire.com/fastly/597b7c9f2c777f1607a52d5780c1bbec55c31d23610b23cba4306abe21a1de78.jpeg",
    "https://cdn.faire.com/fastly/e97e39cfe0682110c40d4ff749187cbe8e2536bda9abd9c67c347eaed27cdd6a.jpeg",
    "https://cdn.faire.com/fastly/90f6ed361b837f1f5ab27373032636d33525e25e18ae797949d10cc721530b34.jpeg",
    "https://cdn.faire.com/fastly/39b62367ab97b1104abd0547895d538a9de853364d4e392a76deea9565193ca9.jpeg",
    "https://cdn.faire.com/fastly/39455643120f78fe3354b34ff8fb53fd2919ca9286595a6f41ef952dc8c9846e.jpeg",
    "https://cdn.faire.com/fastly/73891b48f35c09618f7b50e9d3b7d2fd841ed0001f1d56fa51e11abd9eb801a8.jpeg",
    "https://cdn.faire.com/fastly/5a53dddfa6dbc2f599c56cdf1bc467cf1b480dea45d8b15c87a74fd6c65603d1.jpeg",
    "https://cdn.faire.com/fastly/fd5b007156c3a356725ace0909e34d0ae69b8c4287cd6a14b99d86e242a18f03.jpeg",
    "https://cdn.faire.com/fastly/553d0697b66ab90eeb33097e3b1a9a5c6c3494e080d1fae6907f2ccc093e752d.jpeg",
  ],
  priceDollars: 0.01,
  description:
    "Try all of our best sellers FREE. This deal is FIRE 🌶️🌶️\n🚀 Get a 11 pack of our best sellers for free - no strings attached - massive flash perk - \n⏱️limited time through end of the month! \n➡️➡️Limit 1 set of 11 per cart.  Only add 1 per cart, we ship you 11 units.  If you add 300 we will only ship you 11 :), so please just add 1, thank you!!\n\nItems included:\n1 x Magnesium Oil Body Spray, Full Size 16 oz\n2 x Nighttime Magnesium Cream, Jasmine, 5 oz\n2 x Nighttime Magnesium Cream, Citrus Serenity, 5 oz\n2 x Nighttime Magnesium Lotion with Arnica, Lavender, 5 oz\n2 x Nighttime Magnesium Lotion with Arnica, Woodsman, 5 oz\n2 x Body Soothing Muscle Rub, 5 oz\n\nTotal retail value: $360\n\n✅ Deep, soothing relief with topical magnesium\n✅ helps with restless legs\n✅ Gentle & safe for sensitive skin\n✅ Small-batch crafted in Houston, Texas at our state of the art facility. We make all of our items in house, no outsourcing!\n\nRisk Free!  These are our best sellers, so it's a perfect way to try new items in your store and to discover which ones your customers will come back for again and again!\n\n",
  tags: [],
  msrpDollars: 0.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:28:39.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
